import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import VueSwal from 'vue-swal'
import store from './store'
import VueTheMask from 'vue-the-mask'
import helpers from './helpers'
import { version } from '../package'

import './plugins/dayjs'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/css/modal-full.css'
import './assets/css/style.css'

if (typeof localStorage !== "undefined") {
  const audio = new Audio("https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/lecard-gestor/bell.mp3");
  audio.loop = true;

  Vue.use(VueResource);
  Vue.use(VueSwal);
  Vue.use(helpers);
  Vue.use(VueTheMask);

  const socket_auth = process.env.VUE_APP_SOCKET_AUTH || null;
  const token = localStorage.getItem('key') || null;

  if (token && socket_auth) {
    const base_socket = process.env.VUE_APP_BASE_SOCKET;
    const socketConnection = SocketIO(base_socket, {
      transports: ["websocket", "polling"],
      withCredentials: true,
      auth: { token: socket_auth },
    });

    Vue.use(new VueSocketIO({
      debug: false,
      connection: socketConnection,
    }));
  }

  const isElectron = !!window.control;
  const url_alternativo = (sessionStorage.getItem('base_server') || localStorage.getItem('base_server'));
  const base_server = url_alternativo ? url_alternativo : process.env.VUE_APP_BASE_SERVER;

  Vue.mixin({
    data () {
      return {
        base_server,
        isElectron,
        app_version: version,
        server_alternativo: 'https://api-2.storkdigital.com.br/',
        server_teste: 'https://dev.lecard.app.br/',
        server_beta: 'https://beta.lecard.app.br/',
        base_cdn: "https://lecard-cdn.nyc3.cdn.digitaloceanspaces.com/",
        versao_atual: 164,
        last_versao: 164,
        connect_version: 2,
        wpp_version: 443
      }
    },

    methods: {
      logout(reiniciar, resetar) {
        localStorage.removeItem('key');
        localStorage.removeItem('token');
        localStorage.removeItem('empresas');
        sessionStorage.clear();
        window.location.href = "/";

        if (this.isElectron && (reiniciar || resetar)) {
          window.control.fechar({ reiniciar, resetar });
        }
      }
    }
  });

  Vue.filter('valor', function (value) {
    if (value === undefined || value === null) {
      return value;
    }
    let formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    });
    return formatter.format(value);
  });

  Vue.filter('percent', function (value) {
    if (value !== null || value !== undefined) {
      return parseFloat(value).toFixed();
    }
  });

  Vue.filter('phone', function (phone) {
    if (phone) {
      phone = phone.length > 11 ? phone.substring(2, 13) : phone;

      if (phone.length === 10) {
        return phone.replace(/[^0-9]/g, '')
          .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

      } else if (phone.length === 11) {
        return phone.replace(/[^0-9]/g, '')
          .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      }
    }

    return phone
  })

  Vue.filter('status', function (status) {
    switch (status) {
      case '1':
        return "Ativo";

      case '2':
        return 'Pausado';

      case '3':
        return 'Bloqueado'
    }
  });

  Vue.config.productionTip = false;
  Vue.http.options.emulateJSON = true;
  Vue.http.options.emulateHTTP = true;
  Vue.http.options.root = base_server + 'api/';

  Date.prototype.toDateInputValue = (function() {
    let local = new Date(this);
    local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
    return local.toJSON().slice(0,10);
  });

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}
